import { Category } from '../services/api';

export enum TaskStatus {
    TODO = 'TODO',
    IN_PROGRESS = 'IN_PROGRESS',
    DONE = 'DONE'
}

export interface Task {
    id: number;
    title: string;
    description: string;
    status: TaskStatus;
    dueDate: string;
    priority: number;
    createdAt: string;
    updatedAt: string;
    userId: number;
    googleTaskId?: string;
}

export interface CreateTaskRequest {
    title: string;
    description: string;
    dueDate: string;
    status: TaskStatus;
    priority: number;
} 